const createElement = (type, className, parent) => {
	const element = document.createElement(type);
	
	if( className ) {
		element.className = className;
	}
	
	if( parent ) {
		parent.appendChild(element);
	}
	
	return element;
}

export { createElement }